export default __webpack_public_path__ + "static/1-d127694598d5bd904ee43779ba04e64a.jpeg";